$(document).on('click', '.collectiongrid-layout', function() {
  $(this).addClass('active');
  $(this).siblings().removeClass('active');
  if($(this).hasClass('column-1')){
    $('.product-grid-container').addClass('list-style')
  }
   else{
     $('.product-grid-container').removeClass('list-style')
   } 
});

function formatMoneyKr(amount) {
  return amount.toLocaleString("nb-NO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + " kr";
}

$(document).on("click", ".quantity__button.plus, .quantity__button.minus", function () {
  const $container = $(this).closest(".price-per-item__container");
  const $input = $container.find(".quantity__input");

  let currentQty = parseInt($input.val()) || 1;

  // Set new quantity
  $input.val(currentQty);

  // Get unit price (in cents, convert to normal)
  const unitPrice = parseFloat($input.data("price")) / 100;
  const totalPrice = unitPrice * currentQty;

  // Update price in DOM with formatted money
$(".product-form__buttons .btn-icon .total_price_cart").text(formatMoneyKr(totalPrice));

  console.log("unitPrice===", unitPrice);
  console.log("totalPrice==", totalPrice);
});


// When variant changes → reset quantity and price
$(document).on("change", ".variant-iner-option label", function () {
  const selectedPrice = parseFloat($(this).find(":selected").data("price")) / 100;

  // Reset quantity to 1
  $(".quantity__input").val(1).data("price", selectedPrice * 100); // keep cents for calculation

  // Reset total price display
  $(".product-form__buttons .btn-icon .total_price_cart").text(formatMoneyKr(selectedPrice));
});
